module.exports = __webpack_public_path__ + "static/media/keyvisual-radeberger-2x.1294fd60.jpg";